import React from 'react';
import {
  string,
  shape,
  bool,
  object
} from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { CheckNearByStore } from './CheckNearByStore';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { CHECK_NEARBY_STORES } from '../../../constants';
import { IDS } from '../../../../automationTestIds';

const BOPISOutOfStock = ({
  itemId,
  location,
  isShipToHomeEligible,
  isAppliance,
  addOnsAssemblyAndMore
}) => {
  const { storeName } = useStore();
  return (
    <>
      <div className="u__center">
        <TileHead
          title="Store Pickup"
          icon="pick-up-false"
          automationId={IDS.LABEL.pickupLabel}
        />
        <div className="fulfillment__sub-title" data-automation-id={IDS.UA.pickup_unavailable}>
          <div>Unavailable at</div>
          <div>{location.storeName || storeName }</div>
        </div>
      </div>
      {!isAppliance && (
        <TileFooter>
          <CheckNearByStore
            itemId={itemId}
            isShipToHomeEligible={isShipToHomeEligible}
            addOnsAssemblyAndMore={addOnsAssemblyAndMore}
          >
            { CHECK_NEARBY_STORES }
          </CheckNearByStore>
        </TileFooter>
      )}
    </>
  );
};

BOPISOutOfStock.propTypes = {
  itemId: string.isRequired,
  isShipToHomeEligible: bool,
  isAppliance: bool,
  location: shape({
    storeName: string,
    distance: string
  }),
  // eslint-disable-next-line react/forbid-prop-types
  addOnsAssemblyAndMore: object
};

BOPISOutOfStock.defaultProps = {
  isShipToHomeEligible: false,
  isAppliance: false,
  location: {},
  addOnsAssemblyAndMore: null
};

export { BOPISOutOfStock };
